import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleStudentsNoAppUsageUseCaseInterface } from 'domain/usecases';
import { IStudentsNoAppUsageFilters } from 'presentation/app/modules/Reports/models/students-no-app-usage-filters';

interface IStudentsNoAppUsageState {
  studentsNoAppUsageListData: HandleStudentsNoAppUsageUseCaseInterface.Result;
  studentsNoAppUsageFilters: IStudentsNoAppUsageFilters;
}

interface IPayloadStudentsNoAppUsageListData
  extends PayloadAction<HandleStudentsNoAppUsageUseCaseInterface.Result> {}

interface IPayloadStudentsNoAppUsageFilters
  extends PayloadAction<IStudentsNoAppUsageFilters> {}

const initialState: IStudentsNoAppUsageState = {
  studentsNoAppUsageListData: [],
  studentsNoAppUsageFilters: null,
};

export const StudentsNoAppUsageSlice = createSlice({
  name: 'activity-report-internship',
  initialState,
  reducers: {
    loadStudentsNoAppUsageListData: (
      state,
      action: IPayloadStudentsNoAppUsageListData,
    ) => {
      state.studentsNoAppUsageListData = action.payload;
    },
    clearStudentsNoAppUsageListData: (state) => {
      state.studentsNoAppUsageListData = [];
    },
    loadStudentsNoAppUsageFilters: (
      state,
      action: IPayloadStudentsNoAppUsageFilters,
    ) => {
      state.studentsNoAppUsageFilters = action.payload;
    },
    clearStudentsNoAppUsageFilters: (state) => {
      state.studentsNoAppUsageFilters = null;
    },
  },
});

export const {
  loadStudentsNoAppUsageListData,
  clearStudentsNoAppUsageListData,
  loadStudentsNoAppUsageFilters,
  clearStudentsNoAppUsageFilters,
} = StudentsNoAppUsageSlice.actions;

export default StudentsNoAppUsageSlice.reducer;
